import { CynthaiLogo } from "@cynthai/icons";

export default function Logo({
  size = 32,
  className,
}: {
  readonly size?: number;
  readonly className?: string;
}) {
  return <CynthaiLogo height={size} width={size} className={className} />;
}
